import { jsx as e } from "react/jsx-runtime";
import { c as a, b as c, d as n } from "../../vendor-Blw3V4C-.js";
import { forwardRef as l } from "react";
import '../../assets/index6.css';const i = "_link_2gz6a_1", f = {
  link: i
}, b = l(({ children: o, ...t }, r) => {
  const s = a({
    [f.link]: !0
  });
  return /* @__PURE__ */ e(
    c,
    {
      ...t,
      style: void 0,
      slot: null,
      ref: r,
      className: s,
      target: t.target,
      children: o
    }
  );
}), k = n;
export {
  b as Link,
  k as RouterProvider
};
//# sourceMappingURL=index.js.map
